export default function Trainers() {
  return (
    <section className="py-12 max-w-6xl mx-auto px-5 md:px-8">
      {/* Heading */}
      <div className="text-center mb-10">
        <h2 className="text-3xl md:text-4xl font-black text-white mb-3">
          Certified <span className="text-primary">Training & Coaching</span>
        </h2>
        <p className="text-slate-400 max-w-2xl mx-auto text-sm md:text-base">
          Structured guidance, safe training methods, and goal-oriented programs
          — designed for real results.
        </p>
      </div>

      {/* Main Trainer Card */}
      <div className="max-w-3xl mx-auto mb-10">
        <div className="relative bg-surface-dark border border-slate-800 rounded-2xl p-6 md:p-8 shadow-xl overflow-hidden">
          {/* Accent line */}
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-primary to-transparent" />

          <div className="flex items-start gap-5">
            {/* Icon */}
            <div className="p-4 rounded-xl bg-primary/15 text-primary">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-10 w-10"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={2}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M12 14l9-5-9-5-9 5 9 5zm0 0v6"
                />
              </svg>
            </div>

            {/* Content */}
            <div>
              <h3 className="text-xl md:text-2xl font-bold text-white">
                Himank Monga
              </h3>
              <p className="text-primary text-sm font-semibold mb-2">
                Head Trainer & Program Lead
              </p>

              <p className="text-slate-300 text-sm leading-relaxed mb-3">
                Specializes in strength training, powerlifting fundamentals, and
                injury-safe workout programming. Focused on long-term fitness,
                proper form, and sustainable progress.
              </p>

              <div className="flex flex-wrap gap-3 text-xs">
                <span className="px-3 py-1 rounded-full bg-primary/10 text-primary">
                  8+ Years Experience
                </span>
                <span className="px-3 py-1 rounded-full bg-slate-700/40 text-slate-300">
                  Strength Training
                </span>
                <span className="px-3 py-1 rounded-full bg-slate-700/40 text-slate-300">
                  Injury Prevention
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Support Programs (No Faces) */}
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {[
          {
            title: "Functional Training",
            desc: "Mobility, balance, and everyday strength improvement",
          },
          {
            title: "Cardio & HIIT Programs",
            desc: "Endurance building & fat-loss focused routines",
          },
          {
            title: "Beginner Coaching",
            desc: "Safe guidance for first-time gym members",
          },
        ].map((item, i) => (
          <div
            key={i}
            className="bg-surface-dark border border-slate-800 rounded-xl p-6 hover:border-primary/40 transition-all"
          >
            <div className="mb-4 p-3 inline-flex rounded-lg bg-primary/10 text-primary">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={2}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <h4 className="font-semibold text-white mb-1">{item.title}</h4>
            <p className="text-slate-400 text-sm">{item.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
}


// export default function Trainers() {
//   const trainers = [
//     {
//       name: "Gursewak Singh",
//       role: "Head Trainer",
//       specialty: "Strength & Powerlifting",
//       exp: "8+ years",
//       desc: "Certified in advanced strength training & injury prevention"
//     },
//     {
//       name: "Priya Sharma",
//       role: "Fitness Coach",
//       specialty: "Functional Training & Yoga",
//       exp: "6+ years",
//       desc: "Expert in mobility, core strength & women's fitness"
//     },
//     {
//       name: "Amanpreet Kaur",
//       role: "Cardio & HIIT Specialist",
//       specialty: "Endurance & Fat Loss",
//       exp: "5+ years",
//       desc: "Special focus on high-intensity interval training"
//     },
//   ];

//   return (
//     <section className="py-8 max-w-xl mx-auto px-5">
//       <h2 className="text-xl font-bold text-white mb-4 flex items-center gap-2">
//         <span className="material-symbols-outlined text-primary">group</span>
//         Our Well-Qualified Trainers
//       </h2>
      
//       <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
//         {trainers.map((trainer, i) => (
//           <div 
//             key={i}
//             className="bg-surface-dark border border-slate-800 rounded-xl p-5 hover:border-primary/50 transition-all"
//           >
//             <div className="flex items-center gap-4 mb-3">
//               <div className="w-14 h-14 rounded-full bg-primary/20 flex items-center justify-center shrink-0">
//                 {/* <span className="material-symbols-outlined text-primary text-3xl">person</span> */}
//               </div>
//               <div>
//                 <h3 className="font-bold text-white">{trainer.name}</h3>
//                 <p className="text-primary text-xs font-medium">{trainer.role}</p>
//               </div>
//             </div>
//             <p className="text-slate-300 text-sm mb-2">{trainer.specialty}</p>
//             <p className="text-slate-500 text-xs">{trainer.exp} experience</p>
//             <p className="text-slate-400 text-xs mt-3">{trainer.desc}</p>
//           </div>
//         ))}
//       </div>
//     </section>
//   );
// }